import { ToggleGroup, ToggleGroupItem } from '~components/ui/toggle-group';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */

type CollarOrToe = 'collar' | 'toe';

type CollarOrToeSelectProps = {
  /** Currently selected position */
  selected: CollarOrToe;
  /** Callback when a different position is selected */
  onChange: (selected: CollarOrToe) => void;
};

/* -------------------------------------------------------------------------- */
/*                               Main component                               */
/* -------------------------------------------------------------------------- */

/**
 * Toggle group for selecting whether to render drill holes at their collar
 * (surface entry point) or toe (bottom of the hole) position.
 * Uses single selection mode.
 */
const CollarOrToeSelect = ({ selected, onChange }: CollarOrToeSelectProps) => {
  const handleValueChange = (v: string) => {
    if (v) {
      onChange(v as CollarOrToe);
    }
  };

  return (
    <ToggleGroup type="single" variant="outline" size="lg" block value={selected} onValueChange={handleValueChange}>
      <ToggleGroupItem value="collar">Collar</ToggleGroupItem>
      <ToggleGroupItem value="toe">Toe</ToggleGroupItem>
    </ToggleGroup>
  );
};

/* -------------------------------------------------------------------------- */
/*                                   Exports                                  */
/* -------------------------------------------------------------------------- */

export type { CollarOrToe };
export { CollarOrToeSelect };
